import React from "react";
import { Col, Modal, Row } from "reactstrap";

export default function ShowNew({ modal_center, tog_center, setmodal_center, data }) {
  const fields = [
    { label: "الايميل", value: data.email },
    { label: "الباسورد", value: data.password },
    { label: "رقم الهاتف", value: data.phone },
    { label: "رابط رقم SMS", value: data.sms_url, link: true },
    { label: "رابط الشرح", value: data.guide_url, link: true },
  ];

  const formatLink = (url) => {
    if (!url) return "";
    if (/^https?:\/\//i.test(url)) return url;
    return `https://${url}`;
  };

  return (
    <Modal
      isOpen={modal_center}
      toggle={() => tog_center()}
      centered
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0">Apple 2FA Details</h5>
        <button
          type="button"
          onClick={() => setmodal_center(false)}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body" style={{ direction: "rtl", fontFamily: "Cairo" }}>
        <Row>
          {fields.map((field) => (
            <Col md="12" key={field.label} className="mb-3">
              <strong>{field.label}:</strong>{" "}
              {field.link ? (
                <a
                  href={formatLink(field.value)}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#000972" }}
                >
                  {field.value}
                </a>
              ) : (
                <span>{field.value}</span>
              )}
            </Col>
          ))}
          {data.note ? (
            <Col md="12" className="mb-3">
              <strong>ملحوظة:</strong> <span>{data.note}</span>
            </Col>
          ) : null}
        </Row>
      </div>
    </Modal>
  );
}
